<template>
  <div class="lesson-test-navigation">
    <Button class="-xs-" :is-loading="isLoading" @click="$emit('sendAnswer')">{{ btnName }}</Button>
    <div class="lesson-test-navigation-stepper-container">
      <Stepper
        :current-step-idx="currentQuestionIdx"
        :steps="questions"
        :show-nav-buttons="false"
      ></Stepper>
    </div>
  </div>
</template>

<script>
import Stepper from '@/components/UiKit/v2/Stepper';

export default {
  components: {
    Stepper
  },
  props: ['questions', 'currentQuestionIdx', 'isLoading', 'isChecking'],
  computed: {
    btnName() {
      return this.isChecking ? 'Следующий вопрос' : 'Подтвердить';
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-test-navigation-stepper-container {
  margin-top: 12px;
}
</style>
